var path = 'areas/projects/actions/azure_resource_group/Octopus.AzureResourceGroup_summary.html';
var html = "<p> Deploy an Azure Resource Manager Template <span ng-show='properties[\"Octopus.Action.TargetRoles\"] && isSingleStep'>on behalf of targets in roles: <tag-list tags='properties[\"Octopus.Action.TargetRoles\"]'></tag-list></span> </p>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/azure_resource_group/Octopus.AzureResourceGroup_summary.html
// module id = 6797243917277787
// module chunks = 1